import styled from '@emotion/styled';

const Bullet = styled('span')({
  fontSize: '3rem',
  padding: '0 0.75rem',
});

export default Bullet;
